import { createAction } from '@ngrx/store';
import { baseProps } from 'projects/shared/src/lib/core/store/actions-base';
import {
  NotificationInterface,
  NotificationType,
} from 'projects/shared/src/lib/core/interfaces';

export const addNotification = createAction(
  '[@ciso/notifications] addNotification',
  baseProps<{ notification: NotificationInterface }>(),
);

export const resetNotifications = createAction(
  '[@ciso/notifications] resetNotifications',
  baseProps<{ notificationType: NotificationType }>(),
);
